export default "__VITE_PUBLIC_ASSET__13ae50d8__"